<template>
  <v-container fluid>
    <h1>Rediger kunde</h1>
    <v-text-field label="Kundenavn" v-model="customerData.customer.label"></v-text-field>
    <v-tabs>
      <v-tab ripple>Avdelinger</v-tab>
      <v-tab ripple>Brukere</v-tab>
      <v-tab-item>
        <v-toolbar color="white" flat dense>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat @click="dialogAlterDepartment = !dialogAlterDepartment">legg til avdeling</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-data-table :headers="OrgHeaders" :items="orgWithDepth" hide-actions disable-initial-sort>
          <template v-slot:headers="props">
            <tr>
              <th
                class="text-xs-left"
                v-for="header in props.headers"
                :key="header.text"
              >{{ header.text }}</th>
              <th class="text-xs-right">Aksjon</th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <!-- <td>{{ props.item.id }}</td> -->
              <td>
                <v-icon v-for="n in props.item.depth" :key="n">minimize</v-icon>
                <!-- {{ "-".repeat(props.item.depth)}} -->
              </td>
              <td>{{ props.item.label }}</td>
              <!-- <td>{{ props.item.parentid ? (props.item.depth?"- ".repeat(props.item.depth - 1):"") + props.item.parentobj.label : "" }}</td> -->
              <td>{{ props.item.leader }}</td>
              <td>{{ props.item.email }}</td>
              <td align="right">
                <v-btn flat @click="editDepartment(props.item.id)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn flat @click="deleteDepartment(props.item.id)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>

          <template v-slot:footer></template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-toolbar color="white" flat dense>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat @click="dialogAlterUser = !dialogAlterUser">legg til bruker</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-data-table
          :headers="UserHeaders"
          :items="customerData.users"
          hide-actions
          disable-initial-sort
        >
          <template v-slot:headers="props">
            <tr>
              <th
                class="text-xs-left"
                v-for="header in props.headers"
                :key="header.text"
              >{{ header.text }}</th>
              <th class="text-xs-right">Aksjon</th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <!-- <td>{{ props.item.id }}</td> -->
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.orgLabel }}</td>
              <td>{{ props.item.role }}</td>
              <td align="right">
                <v-btn flat @click="editUser(props.item.id)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn flat @click="deleteUser(props.item.id)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>

          <template v-slot:footer></template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="dialogAlterDepartment">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterDepartmentData.id">Oppdater avdeling</span>
          <span class="display-1 font-weight-bold" v-else>Legg til ny avdeling</span>
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterDepartment" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field label="Navn" v-model="AlterDepartmentData.label"></v-text-field>
              </v-flex>
              <v-flex>
                <v-select
                  :items="
                    [{ id: null, label: 'Toppnivå' }].concat(orgWithDepth)
                  "
                  label="Legges under"
                  item-text="label"
                  item-value="id"
                  v-model="AlterDepartmentData.parentid"
                >
                  <template v-slot:item="{ item, index }">
                    <span v-for="n in item.depth" :key="n">-&nbsp;</span>
                    <span>{{ item.label }}</span>
                  </template>
                </v-select>
              </v-flex>
              <v-flex>
                <v-text-field label="Leder" v-model="AlterDepartmentData.leader"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="E-Post" v-model="AlterDepartmentData.email"></v-text-field>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn
                  v-if="AlterDepartmentData.id"
                  @click="submitEditDepartment"
                  flat
                >Oppdater avdeling</v-btn>
                <v-btn v-else @click="submitAddDepartment" flat>Legg til ny avdeling</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterUser">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterUserData.id">Oppdater bruker</span>
          <span class="display-1 font-weight-bold" v-else>Legg til ny bruker</span>
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterDepartment" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field label="Navn" v-model="AlterUserData.name"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="E-Post" v-model="AlterUserData.email"></v-text-field>
              </v-flex>
              <v-flex v-if="!AlterUserData.id">
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.password"
                  v-model="AlterUserData.password"
                  :append-icon="showpassword ? 'visibility' : 'visibility_off'"
                  @click:append="showpassword = !showpassword"
                  :type="showpassword ? 'text' : 'password'"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-select label="Rolle" :items="userRoles" v-model="AlterUserData.role"></v-select>
              </v-flex>
              <v-flex v-if="AlterUserData.role == 'user'">
                <v-select
                  :items="orgWithDepth"
                  label="Avdeling"
                  item-text="label"
                  item-value="id"
                  v-model="AlterUserData.organisation"
                >
                  <template v-slot:item="{ item, index }">
                    <span v-for="n in item.depth" :key="n">-&nbsp;</span>
                    <span>{{ item.label }}</span>
                  </template>
                </v-select>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn v-if="AlterUserData.id" @click="submitEditUser" flat>Oppdater bruker</v-btn>
                <v-btn v-else @click="submitAddUser" flat>Legg til ny bruker</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions(["GET_CUSTOMER", "ALTER_CUSTOMER"]),
    getCustomerData() {
      this.GET_CUSTOMER(this.customerid)
        .then(resp => {
          this.customerData.customer = resp.data.customer;
          this.customerData.organisations = resp.data.organisations;
          this.customerData.users = resp.data.users;
          this.customerData.admin = resp.data.admin;
        })
        .catch(ex => {
          console.error(ex);
        });
    },
    cancelDialogAlterDepartment() {
      this.resetAlterDepartmentData();
      this.dialogAlterDepartment = false;
    },
    resetAlterDepartmentData() {
      this.AlterDepartmentData.id = null;
      this.AlterDepartmentData.label = "";
      this.AlterDepartmentData.leader = "";
      this.AlterDepartmentData.email = "";
      this.AlterDepartmentData.parentid = null;
    },
    editDepartment(id) {
      let currentDep = this.orgWithDepth.find(res => res.id == id);
      if (currentDep) {
        this.AlterDepartmentData.id = currentDep.id;
        this.AlterDepartmentData.label = currentDep.label;
        this.AlterDepartmentData.leader = currentDep.leader;
        this.AlterDepartmentData.email = currentDep.email;
        this.AlterDepartmentData.parentid = currentDep.parentid;
        this.dialogAlterDepartment = true;
      }
    },
    submitEditDepartment() {
      this.ALTER_CUSTOMER({
        customerid: this.customerid,
        Transfer: "editdepartment",
        data: this.AlterDepartmentData
      }).finally(() => {
        this.dialogAlterDepartment = false;
        this.resetAlterDepartmentData();
        this.getCustomerData();
      });
    },
    submitAddDepartment() {
      this.ALTER_CUSTOMER({
        customerid: this.customerid,
        Transfer: "createdepartment",
        data: this.AlterDepartmentData
      }).finally(() => {
        this.dialogAlterDepartment = false;
        this.resetAlterDepartmentData();
        this.getCustomerData();
      });
    },
    deleteDepartment(departmentid) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne avdelinga?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.customerid,
          Transfer: "deletedepartment",
          data: departmentid
        }).finally(() => {
          this.getCustomerData();
        });
      }
    },
    cancelDialogAlterUser() {
      this.resetAlterUserData();
      this.dialogAlterUser = false;
    },
    resetAlterUserData() {
      this.AlterUserData.id = null;
      this.AlterUserData.name = "";
      this.AlterUserData.email = "";
      this.AlterUserData.password = "";
      this.AlterUserData.role = "";
      this.AlterUserData.organisation = null;
    },
    editUser(id) {
      let currentUser = this.customerData.users.find(res => res.id == id);
      if (currentUser) {
        this.AlterUserData.id = currentUser.id;
        this.AlterUserData.name = currentUser.name;
        this.AlterUserData.email = currentUser.username;
        this.AlterUserData.role = currentUser.role;
        this.AlterUserData.organisation = currentUser.orgId;
        this.dialogAlterUser = true;
      }
    },
    submitEditUser() {
      this.ALTER_CUSTOMER({
        customerid: this.customerid,
        Transfer: "edituser",
        data: this.AlterUserData
      }).finally(() => {
        this.dialogAlterUser = false;
        this.resetAlterUserData();
        this.getCustomerData();
      });
    },
    submitAddUser() {
      this.ALTER_CUSTOMER({
        customerid: this.customerid,
        Transfer: "createuser",
        data: this.AlterUserData
      }).finally(() => {
        this.dialogAlterUser = false;
        this.resetAlterUserData();
        this.getCustomerData();
      });
    },
    deleteUser(userid) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne brukeren?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.customerid,
          Transfer: "deleteuser",
          data: userid
        }).finally(() => {
          this.getCustomerData();
        });
      }
    }
  },
  watch: {
    dialogAlterDepartment(val) {
      if (!val) {
        this.resetAlterDepartmentData();
      }
    },
    dialogAlterUser(val) {
      if (!val) {
        this.resetAlterUserData();
      }
    }
  },
  data() {
    return {
      showPassword: false,
      showpassword: false,
      dialogAlterDepartment: false,
      dialogAlterUser: false,
      userRoles: [
        { text: "Hovedadministrator", value: "admin" },
        { text: "Avdelingsadministrator", value: "user" }
        // { text: "Kun lesetilgang", value: "public" }
      ],
      UserHeaders: [
        { text: "Navn", value: "name", sortable: true },
        {
          text: "Brukernavn",
          value: "username"
        },
        { text: "Avdeling", value: "organisation" },
        { text: "Tilgang", value: "role" }
      ],

      OrgHeaders: [
        // { text: "Avd.Id", value: "id", sortable: true },
        { text: "Nivå", value: "depth", sortable: true },
        { text: "Avdeling", value: "label", sortable: true },
        // {
        //   text: "Under",
        //   value: "parentid"
        // },
        { text: "Leder", value: "leader" },
        { text: "E-Post", value: "email" }
      ],
      customerid: this.$route.params.customerid,
      AlterDepartmentData: {
        id: null,
        label: "",
        parentid: null,
        leader: "",
        email: ""
      },
      AlterUserData: {
        id: null,
        name: "",
        email: "",
        password: "",
        role: "",
        organisation: null
      },
      customerData: {
        customer: {
          id: null,
          adminid: null,
          label: ""
        },
        organisations: [],
        users: [],
        admin: null
      }
    };
  },
  computed: {
    orgWithDepth() {
      let _tmp = this.customerData.organisations.sort(function(a, b) {
        if (a.parent < b.parentid) return -1;
        if (a.parentid > b.parentid) return 1;
        return 0;
      });
      let _sorted = [];
      _tmp.forEach(element => {
        let _currentPath = "";
        let _currentDepth = 0;
        let _sortedElement = false;
        for (var i = 0; i < _sorted.length; i++) {
          if (_sorted[i].id === element.parentid) {
            _sortedElement = _sorted[i];
            break;
          }
        }

        if (_sortedElement) {
          _currentPath = _sortedElement.path;
          _currentDepth = _sortedElement.depth + 1;
        }
        element.path = _currentPath + element.label;
        element.depth = _currentDepth;
        _sorted.push(element);
      });
      let _return = _sorted.sort(function(a, b) {
        if (a.path < b.path) return -1;
        if (a.path > b.path) return 1;

        return 0;
      });
      return _return;
    }
  },

  mounted() {
    this.getCustomerData();
  }
};
</script>
